import VModal from 'vue-js-modal';

export default VModal;
